export * from './urlMatcher';
export * from './urlMatcherFactory';
export * from './urlRouter';
export * from './urlRule';
export * from './urlService';
export { UrlRules } from './urlRules';
export { UrlConfig } from './urlConfig';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/url/index.js
// module id = 557
// module chunks = 1